import React from 'react';
import { SundayRow, shortDate } from './model';

/**
 * The season on sheets for clergy and the office. Status and song ideas are
 * working information and are deliberately left off.
 */
const ROWS_PER_SHEET = 7;

const PrintSheets: React.FC<{ rows: SundayRow[] }> = ({ rows }) => {
  const sheets: SundayRow[][] = [];
  for (let i = 0; i < rows.length; i += ROWS_PER_SHEET) {
    sheets.push(rows.slice(i, i + ROWS_PER_SHEET));
  }

  return (
    <>
      <div className="sv-printnote">
        Season on {sheets.length === 1 ? 'one sheet' : `${sheets.length} sheets`} for clergy and the
        office. Status and song ideas are working information and are left off.{' '}
        <button className="sv-add" onClick={() => window.print()}>Print</button>
      </div>

      {sheets.map((sheet, i) => (
        <div className="sv-sheet" key={i}>
          <div className="sv-sheet-head">
            <div className="sv-eyebrow">Music · St Luke's ~ San Lucas</div>
            <div className="sv-serif" style={{ fontSize: 20 }}>
              {shortDate(sheet[0].date)} — {shortDate(sheet[sheet.length - 1].date)}
            </div>
          </div>

          {sheet.map(r => {
            const shown = r.placements.filter(p => !p.recurring);
            return (
              <div className="sv-sheet-row" key={r.date}>
                <div>
                  <div className="sv-dateline">{r.dateLine}</div>
                  <div className="sv-serif" style={{ fontSize: 14, lineHeight: 1.2 }}>{r.day}</div>
                </div>
                <div>
                  <div className="sv-sheet-lang">10:00 English</div>
                  {shown.filter(p => p.en).slice(0, 6).map(p => <div key={p.key}>{p.en}</div>)}
                </div>
                <div>
                  <div className="sv-sheet-lang">12:30 Español</div>
                  {shown.filter(p => p.es).slice(0, 6).map(p => <div key={p.key}>{p.es}</div>)}
                </div>
                <div>
                  {r.organ.map(o => <div key={o.id}>{o.slot}: {o.work}</div>)}
                  {r.people
                    .filter(m => m.status !== 'declined')
                    .map(m => <div key={m.id}>{m.name}{m.instrument ? `, ${m.instrument}` : ''}</div>)}
                </div>
              </div>
            );
          })}

          <div className="sv-sheet-foot">
            Rehearsals · Choir Tuesdays 6:30 · Instrumentalists Wednesdays 7:15
          </div>
        </div>
      ))}
    </>
  );
};

export default PrintSheets;
